// this module contains functions for init and accessing UCMS settings
// the settings are gathered using scraping fo-site listing page HTML from <script id="app.settings" type="application/json-ld">
// element
let settings = {};

const Settings = {
  settings: {},

  initSettings: (newSettings) => {
    settings = newSettings;
  },

  /**
   * Get setting from desired place
   * @param {string} key
   * @param {number} [type]
   */
  get: (key) => (typeof settings[key] !== 'undefined' ? settings[key] : undefined)
};


export default Settings;
